/** @format */
import { lazyLoadRoutes } from './LazyLoadRoutes';
const paths = [
  {
    element: lazyLoadRoutes('HomeParent'),
    path: '/Home',
    auth: true,
    key: ['dashboard'],
  },
  {
    path: '*',
    auth: true,
    element: lazyLoadRoutes('NotFound'),
  },
  {
    path: '/notfound',
    auth: true,
    element: lazyLoadRoutes('NotFound'),
  },
  {
    element: lazyLoadRoutes('GetFile'),
    path: '/getFile/:id',
    auth: true,
  },

  {
    element: lazyLoadRoutes('Keys/KeysList'),
    path: '/Keys',
    auth: true,
    key: ['clients.list'],
  },
  {
    element: lazyLoadRoutes('Keys/KeyNew'),
    path: '/Keys/AddApiKey',
    auth: true,
    key: ['clients.add'],
  },
  {
    element: lazyLoadRoutes('Keys/KeyEdit'),
    path: '/Keys/EditApiKey/:client_id',
    auth: true,
    key: ['clients.list'],
  },

  {
    element: lazyLoadRoutes('ServiceCall'),
    path: '/services/service-calls',
    auth: true,
    key: ['service.request.calls'],
  },

  {
    element: lazyLoadRoutes('Financial/DetailAccounts/ListDetailAccounts'),
    path: '/Guilds',
    auth: true,
    key: ['bfo.guilds.list', 'dashboard.guild.account'],
  },
  {
    element: lazyLoadRoutes('Cards'),
    path: '/cards',
    auth: true,
    key: ['bfo.cards'],
  },
  {
    element: lazyLoadRoutes('Financial/GrantPermissionRequests'),
    path: '/grant-permission/list',
    auth: true,
    key: ['bfo.guilds.grant-permission.list'],
  },

  // ================================= مجوز های اعطا شده صفحات جدا شد =======================
  {
    element: lazyLoadRoutes('Permission/GrantedWallet'),
    path: '/Permission/GrantedWallet',
    auth: true,
    key: ['accounts.digital.granted-permissions.read', 'org.imprest.accounts.digital.granted-permissions.read'],
  },

  {
    element: lazyLoadRoutes('Permission/GrantedGuild'),
    path: '/Permission/GrantedGuild',
    auth: true,
    key: ['accounts.guild.granted-permission.read'],
  },
  // ========================  مجوز های دریافت شده تفصیلی و دیجیتال ========================
  {
    element: lazyLoadRoutes('Permission/ReceivedGuild'),
    path: '/Permission/ReceivedGuild',
    auth: true,
    key: ['accounts.guild.receive-permission.read'],
  },
  {
    element: lazyLoadRoutes('Permission/ReceivedWallet'),
    path: '/Permission/ReceivedWallet',
    auth: true,
    key: ['accounts.digital.received-permissions.list', 'org.imprest.accounts.digital.received-permissions.list'],
  },
  // ============================================================================================

  {
    element: lazyLoadRoutes('DigitalAccount/MyDigitalAccount'),
    path: '/Accounts',
    auth: true,
    key: ['bfo.accounts.list', 'dashboard.digital.account'],
  },

  {
    element: lazyLoadRoutes('TransferCredit/TransferCreditByMenu'),
    path: '/TransferCredit',
    auth: true,
    key: [
      'bfo.accounts.transfer',
    ],
  },

  {
    element: lazyLoadRoutes('TransferCredit/TransferScore'),
    path: '/TransferScore',
    auth: true,

  },

  {
    element: lazyLoadRoutes('TransferCredit/TransferScoreList'),
    path: '/TransferScoreList',
    auth: true,
    key: [
      'org.score',
    ],
  },

  //================= عملیات های گروهی =================================
  {
    element: lazyLoadRoutes('GroupTransactions/GroupDelegation'),
    path: '/GroupDelegationList',
    auth: true,
    key: [
      'accounts.delegation.create',
      'accounts.delegation.guild.create',
    ],
  },
  {
    element: lazyLoadRoutes('GroupTransactions/GroupTransferCredit'),
    path: '/GroupTransferCreditList',
    auth: true,
    key: [
      'bfo.accounts.transfer',
    ],
  },

  {
    element: lazyLoadRoutes('GroupTransactions/GroupTransferDetailsNew'),
    path: '/GroupTransfercredit/:id',
    auth: true,
    key: [
      'bfo.accounts.transfer',
    ],
  },
  {
    element: lazyLoadRoutes('GroupTransactions/GroupDelegationDetails'),
    path: '/GroupDelegation/:id',
    auth: true,
    key: [
      'accounts.delegation.create',
      'accounts.delegation.guild.create',
    ],
  },

  //===================================================================================

  {
    element: lazyLoadRoutes('DigitalAccount/DirectDebit'),
    path: '/DirectDebit',
    auth: true,
    key: ['bfo.accounts.direct-debit.list'],
  },
  {
    element: lazyLoadRoutes('DigitalAccount/WithdrawRule'),
    path: '/WithdrawRule',
    auth: true,
    key: ['bfo.accounts.withdraw-rule.list'],
  },

  {
    element: lazyLoadRoutes('DigitalAccount/DelegationByMenu'),
    path: '/DefineDelegation',
    auth: true,
    key: [
      'accounts.delegation.create'
    ],
  },
  {
    element: lazyLoadRoutes('DigitalAccount/AssignedDelegationReportPages'),
    path: '/DefineDelegation/List',
    auth: true,
    key: [
      'bfo.delegation.define.list', 'services.branches.financial', 'services.imprest.financial',
    ],
  },
  {
    element: lazyLoadRoutes('DigitalAccount/ReceivedDelegationList'),
    path: '/Delegation',
    auth: true,
    key: ['bfo.delegation.list'],
  },
  {
    element: lazyLoadRoutes('DigitalAccount/DiscountCode/CreateDiscount'),
    path: '/Voucher/AddVoucher',
    auth: true,
    key: ['org.vouchers.define', 'financial.followers.list.customers.voucher.button'],
  },
  {
    element: lazyLoadRoutes('DigitalAccount/DiscountCode/DiscountCodes'),
    path: '/Voucher',
    auth: true,
    key: ['org.vouchers.list', 'org.voucher.list'],
  },
  {
    element: lazyLoadRoutes('DigitalAccount/DiscountCode/DiscountDetail'),
    path: '/Voucher/Detail/:id',
    auth: true,
    key: ['org.voucher.list.detail.button', 'org.voucher.list'],
  },
  {
    element: lazyLoadRoutes('DigitalAccount/CreditVoucher/CreateCreditVoucher'),
    path: '/Voucher/AddCreditVoucher',
    auth: true,
    key: ['org.creditvoucher.define', 'financial.followers.list.customers.credit-voucher.button'],
  },
  {
    element: lazyLoadRoutes('DigitalAccount/CreditVoucher/CreditVouchers'),
    path: '/CreditVoucher',
    auth: true,
    key: ['org.creditvoucher.list'],
  },
  {
    element: lazyLoadRoutes('DigitalAccount/CreditVoucher/CreditVoucherDetail'),
    path: '/CreditVoucher/:id',
    auth: true,
    key: ['org.credit-voucher.list.detail.button'],
  },

  {
    element: lazyLoadRoutes('Financial/IncomeByGuild'),
    path: '/IncomeByGuilds',
    auth: true,
    key: ['financial.income-guilds'],
  },
  {
    element: lazyLoadRoutes('Financial/IncomeByProduct'),
    path: '/IncomeByProducts',
    auth: true,
    key: ['financial.income-products'],
  },
  {
    element: lazyLoadRoutes('Subscription/CreateSubscription'),
    path: '/subscriptions/create',
    auth: true,
    key: ['service.subscriptions.define', 'service.subscriptions.list.new-subscription.button'],
  },
  {
    element: lazyLoadRoutes('Subscription/AssignedSubscriptions'),
    path: '/subscriptions/assigned',
    auth: true,
    key: ['service.subscriptions.list', 'service.subscriptions.define.back-to-list.button'],
  },
  {
    element: lazyLoadRoutes('Subscription/CreateSubscription'),
    path: '/subscriptions/assigned/:id',
    auth: true,
    key: ['service.subscriptions.list.edit-subscription.button'],
  },
  {
    element: lazyLoadRoutes('Subscription/AssignedSubscriptions/components/DelegationDetails'),
    path: '/subscriptions/assigned/delegation-details/:id',
    auth: true,
    key: ['service.subscriptions.list'],
  },
  {
    element: lazyLoadRoutes('Subscription/ReceivedSubscriptions'),
    path: '/subscriptions/received',
    auth: true,
    key: ['service.subscriptions.active'],
  },
  {
    element: lazyLoadRoutes('Subscription/ReceivedSubscriptions/components/ReceivedSubscriptionsList'),
    path: '/subscriptions/received/:id',
    auth: true,
    key: ['service.subscriptions.active.details.button'],
  },
  {
    element: lazyLoadRoutes('Financial/InvoiceDetailSell'),
    path: '/Invoice/:id/invoice-details',
    auth: true,
    key: ['accounts.guild.invoice.read.operation', 'financial.followers.list.customer-invoices.operation', 'financial.invoice.operation'],
  },
  {
    element: lazyLoadRoutes('Financial/ReduceInvoice'),
    path: '/Invoice/:id/invoice-reduce',
    auth: true,
    key: ['accounts.guild.invoice.read.operation', 'financial.followers.list.customer-invoices.operation', 'financial.invoice.operation'],
  },

  {
    element: lazyLoadRoutes('Financial/FactorsCreditor/FactorDetails'),
    path: '/InvoiceCreditor/:id/factor-details',
    auth: true,
  },
  {
    element: lazyLoadRoutes('Financial/InvoiceList'),
    path: '/Invoice',
    auth: true,
    key: ['financial.invoice.list', 'accounts.guild.invoice.read', 'financial.followers.list.customer-invoices.button'],
  },

  {
    element: lazyLoadRoutes('Financial/IssueInvoice'),
    path: '/IssueInvoice',
    auth: true,
    key: ['financial.issue-invoice', 'financial.followers.list.customers.issue-invoice.button'],
  },

  {
    element: lazyLoadRoutes('Financial/IssueInvoice/ProfileList'),
    path: '/ProfileListInvoice',
    auth: true,
    key: ['financial.issue-invoice', 'financial.invoice.list', 'financial.followers.list'],
  },
  {
    element: lazyLoadRoutes('Financial/IssueInvoice/ProfileListDetail'),
    path: '/ProfileDetailInvoice',
    auth: true,
    key: ['accounts.guild.invoice.read.payment', 'financial.invoice.payment', 'financial.followers.list.customer-invoices.payment'],
  },
  {
    element: lazyLoadRoutes('Transactions/TransactionsWalletReport'),
    path: '/TransactionsWallet/:accountId',
    auth: true,
    key: ['accounts.digital.report', 'org.imprest.accounts.list.digital.report'],
  },
  {
    element: lazyLoadRoutes('Transactions/TransactionsGuildReport'),
    path: '/TransactionsGuild/:accountId',
    auth: true,
    key: ['accounts.guild.report'],
  },
  {
    element: lazyLoadRoutes('Transactions/TransactionsWalletReport'),
    path: '/TransactionsWallet',
    auth: true,
    key: ['bfo.accounts.transactions'],
  },

  {
    element: lazyLoadRoutes('Transactions/TransactionsGuildReport'),
    path: '/TransactionsGuild',
    auth: true,
    key: ['bfo.guilds.transactionsGuild'],
  },
  {
    element: lazyLoadRoutes('SettlementList/settlementListWalletReport'), // درخواست تسویه دیجیتال
    path: '/SettlementWallet',
    auth: true,
    key: ['bfo.accounts.settlement-list-wallet'],
  },
  {
    //element: lazyLoadRoutes('SettlementList/settlementListGuild'), // درخواست تسویه تفصیلی
    element: lazyLoadRoutes('SettlementList/SettlementListGuildReport'), // درخواست تسویه تفصیلی
    path: '/SettlementGuild',
    auth: true,
    key: ['bfo.guilds.settlement-list', 'accounts.guild.settlement.read.button', 'accounts.guild.settlement.export'],
  },

  {
    element: lazyLoadRoutes('Subscription/ReceivedSubscriptions'),
    path: '/SettlementList/Invoices',
    auth: true,
    key: ['service.subscriptions.active'],

  },
  {
    element: lazyLoadRoutes('Financial/SettlementDetails'),
    path: '/SettlementList/:id/details',
    auth: true,
    key: ['bfo.guilds.settlement-list',
      'bfo.accounts.settelment-list-wallet',
      'accounts.guild.settlement.read.button',
      'bfo.accounts.settlement-list-wallet',
      'org.imprest.accounts.settlement-list-wallet'],
  },
  {
    element: lazyLoadRoutes('Financial/InvoiceDetails'),
    path: '/Invoice/:id/details',
    auth: true,
    key: ['financial.invoice.creditor.details.button', 'financial.invoice.creditor'],
  },
  {
    element: lazyLoadRoutes('Financial/FactorsCreditor'),
    path: '/InvoiceCreditor',
    auth: true,
    key: ['financial.invoice.creditor'],
  },
    {
    element: lazyLoadRoutes('Imprest/ImprestList/ReportSummeryImprest'),
    path: '/Imprest/ReportSummary/:id',
    auth: true,
    key: ['services.imprest.report'],
  },
  {
    element: lazyLoadRoutes('TransferCredit/TransferGuild'),
    path: '/TransferCreditGuild/:id',
    auth: true,
    key: ['accounts.guild.transfer-to-me'],
  },
  {
    element: lazyLoadRoutes('TransferCredit/TransferWallet'),
    path: '/TransferCreditWallet/:id',
    auth: true,
    key: ['accounts.digital.transfer-to-me', 'bfo.accounts.list', 'org.imprest.accounts.digital.transfer-to-me'],
  },
  {
    element: lazyLoadRoutes('Financial/DetailAccounts/ListDetailAccounts/components/CartableWithdrawal'), //  حساب تفصیلی - برداشت وجه تفصیلی از نوع کارتابل
    path: '/GuildCartableCashOut/:id',
    auth: true,
    key: ['accounts.guild.withdraw'],
  },
  {
    element: lazyLoadRoutes('Cashout/CashoutDigital'), // حساب تفصیلی - برداشت وجه تفصیلی
    path: '/WalletCashout/:id',
    auth: true,
    key: ['accounts.digital.single-withdraw', 'org.imprest.accounts.digital.single-withdraw'],
  },
  {
    element: lazyLoadRoutes('Cashout/CashoutGuild'), // حساب تفصیلی - برداشت وجه تفصیلی
    path: '/GuildCashout/:id',
    auth: true,
    key: ['accounts.guild.withdraw'],
  },

  {
    element: lazyLoadRoutes('Business'),
    path: '/BusinessInfo',
    auth: true,
    key: ['bim.businessInfo', 'dashboard.update.business'],
  },
  {
    element: lazyLoadRoutes('ConfirmationRequests/Requests'),
    path: '/RequestConfirmation',
    auth: true,
    key: ['bim.auth', 'bim.businessInfo'],
  },
  {
    element: lazyLoadRoutes('ConfirmationRequests/RequestDetail'),
    path: '/RequestConfirmation/:id',
    auth: true,
    key: ['bim.auth', 'bim.businessInfo'],
  },
    {
    element: lazyLoadRoutes('ConfirmationRequests/RequestEdit'),
    path: '/RequestConfirmationEdit/:id',
    auth: true,
    key: ['bim.auth', 'bim.businessInfo'],
  },
  {
    element: lazyLoadRoutes('ConfirmationRequests/NewRequest'),
    path: '/NewRequestConfirmation',
    auth: true,
    key: ['bim.businessInfo', 'bim.auth.new.request'],
  },
  {
    element: lazyLoadRoutes('ReportRequested'),
    path: '/RequestWebServices',
    auth: true,
    key: ['service.request.list'],
  },
  {
    element: lazyLoadRoutes('UserSettings'),
    path: '/user-settings',
    auth: true,
    key: ['bim.user-management'],
  },
  {
    element: lazyLoadRoutes('Customers/customerListReport'),
    path: '/Followers',
    auth: true,
    key: ['financial.followers.list'],
  },
  {
    element: lazyLoadRoutes('Dealer/MyDealer'),
    path: '/Dealer/List',
    auth: true,
    key: ['org.dealer.list'],
  },
  {
    element: lazyLoadRoutes('Dealer/MyDealing'),
    path: '/Dealer/DealingList',
    auth: true,
    key: ['org.dealing.list'],
  },

  {
    element: lazyLoadRoutes('Subsets/SubsetList'),
    path: '/SubBusiness',
    auth: true,
    key: ['org.branch.subbusiness.list'],
  },
  {
    element: lazyLoadRoutes('Subsets/SubsetDetail'),
    path: '/SubBusiness/Detail',
    auth: true,
    key: ['services.subbusiness.detail'],
  },
  {
    element: lazyLoadRoutes('Subsets/AddSubsetNew'),
    path: '/SubBusiness/Add',
    auth: true,
    key: ['org.branch.subbusiness.define'],
  },
  {
    element: lazyLoadRoutes('Subsets/Branches/EditBranch'),
    path: '/Branch/:id',
    auth: true,
    key: ['services.branches.operation'],
  },
  {
    element: lazyLoadRoutes('Subsets/EditSubset'),
    path: '/SubBusiness/:id',
    auth: true,
    key: ['services.subbusiness.update'],
  },
  {
    element: lazyLoadRoutes('Subsets/Branches/BranchList'),
    path: '/Branch',
    auth: true,
    key: ['org.branch.list'],
  },
  {
    element: lazyLoadRoutes('ReportPages/BranchTransActionReport'),
    path: '/Branch/Transactions/:id',
    auth: true,
    key: ['services.branches.report', 'services.imprest.report', 'services.all.imprest.operation', 'services.imprest.list.report' ,'services.branch.list.report'],
  },
  {
    element: lazyLoadRoutes('ReportPages/MenuBranchTransActionReport'),
    path: '/Branch/Transactions',
    auth: true,
    key: ['org.branch.transactions'],
  },
  {
    element: lazyLoadRoutes('Transactions/MenuImprestTransActionReport'),
    path: '/Imprest/Transactions',
    auth: true,
    key: ['org.imprest.transactions'],
  },
  {
    element: lazyLoadRoutes('Imprest/ImprestList'),
    path: '/Imprest',
    auth: true,
    key: ['org.imprest.list'],
  },
  {
    element: lazyLoadRoutes('Imprest/ImprestSettelment'),
    path: '/Imprest/SettlementList/:id',
    auth: true,
    key: ['org.imprest.list'],
  },
  {
    element: lazyLoadRoutes('Imprest/ImprestDepositReport'),
    path: '/Imprest/DepositReport/:id',
    auth: true,
    key: ['services.imprest.report'],
  },
  {
    element: lazyLoadRoutes('Imprest/ImprestRecieveInventory'),
    path: '/Imprest/ReceiveInventory/:id',
    auth: true,
    key: ['services.imprest.report'],
  },
  {
    element: lazyLoadRoutes('Imprest/AddImprest'),
    path: '/Imprest/Add',
    auth: true,
    key: ['org.imprest.define', 'services.imprest.create.button'],
  },
  {
    element: lazyLoadRoutes('Imprest/ImprestTransferCredit'),
    path: '/Imprest/ImprestTransferCredit',
    auth: true,
    key: ['services.imprest.other'],
  },
  {
    element: lazyLoadRoutes('Imprest/EditImprest'),
    path: '/Imprest/:id',
    auth: true,
    key: ['services.imprest.operation'],
  },
  {
    element: lazyLoadRoutes('Imprest/ImprestIssueInvoice'),
    path: '/Imprest/IssueInvoice/:businessId',
    auth: true,
    key: ['services.imprest.other'],
  },

  {
    element: lazyLoadRoutes('Imprest/ImprestFunderReport'),
    path: '/FunderImprestReport',
    auth: true,
    key: ['org.imprest.funder'],
  },

  {
    element: lazyLoadRoutes('Funder/FunderTransAction'),

    path: '/Funder/Transactions/:id',
    auth: true,
    key: ['funder.list', 'org.imprest.funder'],
  },

  {
    element: lazyLoadRoutes('Subsets/Branches/BranchDetail'),
    path: '/Branch/:id/detail',
    auth: true,
    key: ['services.branches.report', 'services.imprest.report'],
  },
  {
    element: lazyLoadRoutes('Subsets/Branches/BranchFinancial'),
    path: '/Branch/:id/financial',
    auth: true,
    key: ['services.branches.financial', 'services.imprest.financial'],
  },
  {
    element: lazyLoadRoutes('Subsets/Branches/AddBranch'),
    path: '/Branch/Add',
    auth: true,
    key: ['org.branch.define'],
  },

  {
    element: lazyLoadRoutes('Withdraws/components/NewWIthdrawRule'),
    path: '/WithdrawRules/NewRule',
    auth: true,
    key: ['bfo.withdraw-rules.define'],
  },
  {
    element: lazyLoadRoutes('Loan/LoanProvider'),
    path: '/Loan',
    auth: true,
    key: ['org.loan.sales'],
  },

  {
    element: lazyLoadRoutes('Loan/ReceivedLoan'),
    path: '/LoanInvoice',
    auth: true,
    key: ['org.loan.list'],
  },
  {
    element: lazyLoadRoutes('Loan/LoanDetails'),
    path: '/Loan/:id/details',
    auth: true,
    key: ['org.loan.list'],
  },
  {
    element: lazyLoadRoutes('Withdraws/components/CustomersWithdraws'),
    path: '/WithdrawRules/CustomersRules',
    auth: true,
    key: ['bfo.withdraw-rules.customers'],
  },
  {
    element: lazyLoadRoutes('Withdraws/components/WithdrawRules'),
    path: '/WithdrawRules/RulesList',
    auth: true,
    key: ['bfo.withdraw-rules.list'],
  },

  {
    element: lazyLoadRoutes('WebServices/ListWebService'),
    path: '/WebService',
    auth: true,
    key: ['service.webservice.list'],
  },
  {
    element: lazyLoadRoutes('RequestReceived/RequestReceivedPage'),
    path: '/ReceivedRequestWebService',
    auth: true,
    key: ['service.webservice.serviceset.request'],
  },
  {
    element: lazyLoadRoutes('RequestReceived/AsServiceSet/components/DetailRequestReceived'),
    path: '/ReceivedRequestWebService/:invoiceId/detail',
    auth: true,
    key: ['service.webservice.serviceset.request'],

  },
  {
    element: lazyLoadRoutes('WebServices/DefineWebService2'),
    path: '/WebService/Add',
    auth: true,
    key: ['service.webservice.define'],
  },
  {
    element: lazyLoadRoutes('WebServices/DefineWebService2'),
    path: '/services/web-services/:id/edit',
    auth: true,
    key: ['service.web-service.list.edit.button'],

  },
  {
    element: lazyLoadRoutes('ServiceSet/ListServiceSets'),
    path: '/services/service-set',
    auth: true,
    key: ['service.webservice.serviceset.list'],
  },
  {
    element: lazyLoadRoutes('ServiceSet/CreateServiceSet'),
    path: '/services/service-set/create',
    auth: true,
    key: ['service.webservice.serviceset.add'],
  },
  {
    element: lazyLoadRoutes('WebServices/ListWebService/components/VersionService'),
    path: '/services/version/:id',
    auth: true,
    key: ['service.webservice.list'],

  },
  {
    element: lazyLoadRoutes('MyServiceCall'),
    path: '/services/my-service-calls',
    auth: true,
    key: ['service.webservice.service-calls'],
  },
  {
    element: lazyLoadRoutes('ServiceProvider'),
    path: '/services/service-providers',
    auth: true,
    key: ['service.webservice.service-providers'],
  },
  {
    element: lazyLoadRoutes('ServiceSet/CreateServiceSet'),
    path: '/services/service-set/:id/edit',
    auth: true,
    key: ['service.web-service.service-set.list.edit.button'],
  },
  {
    element: lazyLoadRoutes('Ticket/TicketSale'),
    path: '/Ticket/List/sale',
    auth: true,
    key: ['ticketing.list.sale'],
  },
  {
    element: lazyLoadRoutes('Ticket/TicketSupport'),
    path: '/Ticket/List/support',
    auth: true,
    key: ['ticketing.list.support'],
  },
  {
    element: lazyLoadRoutes('Ticket/Detail'),
    path: '/ticket/:ticketId/:ticketPId/:projectId/detail',
    auth: true,
    key: ['ticketing.list.support.details.button', 'ticketing.list.sale.detail.button'],
  },
  {
    element: lazyLoadRoutes('Ticket/create'),
    path: '/Ticket/Create',
    auth: true,
    key: ['ticketing.list.support.page.create', 'ticketing.list.sale.page.create', 'ticketing.create.page'],
  },

  {
    element: lazyLoadRoutes('ACL/ACLList'),
    path: '/Acl',
    auth: true,
    key: ['bim.acl.group'],
  },
  {
    element: lazyLoadRoutes('ACL/ACLAddNew'),
    path: '/Acl/AddGroup',
    auth: true,
    key: ['acl.groups.create'],
  },
  {
    element: lazyLoadRoutes('ACL/ACLEdit'),
    path: '/Acl/EditGroup/:path',
    auth: true,
    key: ['acl.groups.update'],
  },
  {
    element: lazyLoadRoutes('ACL/ACLUserList'),
    path: '/Acl/AddUser/:path',
    auth: true,
    key: ['acl.user.groups.add'],
  },

  {
    element: lazyLoadRoutes('Cartable/CartableList'),
    path: '/Cartable/List',
    auth: true,
    key: ['bfo.cartable.list'],
  },
  {
    element: lazyLoadRoutes('Cartable/CarTableTransferCredit'),
    path: '/CartableTransferCredit/:id',
    auth: true,
    key: ['bfo.accounts.transfer'],
  },
  {
    element: lazyLoadRoutes('Cartable/CartableDefineDelegation'),
    path: '/CartableDelegation',
    auth: true,
    key: ['bfo.delegation.define'],
  },
  {
    element: lazyLoadRoutes('Cartable/CartableWithdrawal'),
    path: '/CartableCashOut',
    auth: true,
    key: ['accounts.guild.withdraw', 'accounts.digital.single-withdraw'],
  },
  {
    element: lazyLoadRoutes('Cartable/CartableRequestList'),
    path: '/CartableRequest/List',
    auth: true,
    key: ['bfo.cartable.Request.list', 'accounts.guild.cartable-requests.read.button', 'accounts.cartable.read.button'],
  },
  {
    element: lazyLoadRoutes('Cartable/RequestPayDetails'),
    path: '/RequestPayDetails/:id',
    auth: true,
    key: ['bfo.cartable.Request.list.details', 'accounts.guild.cartable-requests.read.button.detail'],
  },
  {
    element: lazyLoadRoutes('BonusCards/BonusCartList'),
    path: '/BonusCard/List',
    auth: true,
  },
  {
    element: lazyLoadRoutes('Report/WalletAndGuild'),
    path: '/WalletAndGuild',
    auth: true,
    key: ['dashboard.wallet-guild-report.read']
  },
  {
    element: lazyLoadRoutes('ReportOfflineTransactions'),
    path: '/ReportOfflineTransactions',
    auth: true,
    key: [
      'accounts.digital.report.offline',
      'accounts.guild.report.export',
      'accounts.digital.report.export',
      'accounts.guild.report.transaction.read',
      'services.imprest.report',
      'dashboard.wallet-guild-report.export',
      'dashboard.wallet-guild-report.offline-report',
      'services.all.imprest.export',
      'org.imprest.transactions.report.export',
      'org.imprest.accounts.digital.report.export',
      'bfo.accounts.list.accounts.report.export',
      'org.imprest.accounts.list.digital.report.export',
      'accounts.digital.settlement.export',
      'org.imprest.accounts.digital.settlement.export',
      'accounts.guild.invoice.export',
      'accounts.guild.settlement.read.button.export',
      'accounts.guild.settlement.export',
      'accounts.delegation.other.export',
      'bfo.guilds.transactionsGuild.report.export',
      'org.branch.transactions.report.export',
      'service.web-service.service-set.list.export.button',
      'service.web-service.service-calls.export.button',
      'service.web-service.service-providers.export',
      'service.web-service.service-set.request.export.button',
      'service.request.calls.export.button',
      'service.request.list.export.button',
      'financial.invoice.list.export.button',
      'financial.income-guilds.export.button',
      'financial.income-products.report.export.button',
      'org.loan.sales.export.button',
      'org.voucher.list.export.button',
      'org.credit-voucher.export.button',
      'services.all.aggregation.imprest.export',
      'accounts.delegation.self.export'
    ],
  },
  {
    element: lazyLoadRoutes('Ticket/Faq'),
    path: '/Faq',
    auth: true,
    // key: ['ticketing.faq'],
  },
  {
    element: lazyLoadRoutes('FinancialSupply/FinancialRequests'),
    path: '/InvoiceFinancing/Requests',
    auth: true,
    key: ['org.invoice-financing.request'],
  },
  {
    element: lazyLoadRoutes('FinancialSupply/FinancialInvoices'),
    path: '/InvoiceFinancing/Invoices',
    auth: true,
    key: ['org.invoice-financing.invoices'],
  },
  {
    element: lazyLoadRoutes('FinancialSupply/FinancialInvoicesDetails'),
    path: '/InvoiceFinancing/Invoices/:id',
    auth: true,
  },
  {
    element: lazyLoadRoutes('Warranty/RequestWarranty'), //صدور ضمانت نامه
    path: '/Warranty/Request',
    auth: true,
    key: ['org.warranty.requests'],
  },
  {
    element: lazyLoadRoutes('Warranty/RequestList'), // مسیر کامپوننت استفاده شده : منوی تامین مالی - فاکتورهای تامین مالی شده - عملیات  مشاهده و پرداخت
    path: '/Warranty/RequestList',
    auth: true,
    key: ['org.warranty.list'],
  },
  {
    element: lazyLoadRoutes('Warranty/RequestDetail'), // مسیر کامپوننت استفاده شده : منوی تامین مالی - فاکتورهای تامین مالی شده - عملیات  مشاهده و پرداخت
    path: '/Warranty/RequestDetail/:id',
    auth: true,
    key: ['org.warranty.detail'],
  },
  {
    element: lazyLoadRoutes('DigitalAccount/WalletCartable'), // حساب دیجیتال - برداشت وجه کارتابلی
    path: '/WalletCartableCashout/:id',
    auth: true,
    Key: ['accounts.digital.single-withdraw']
  },
  {
    element: lazyLoadRoutes('TransferCredit/TransferToBranch'), // انتقال وجه شعب
    path: '/TransferToBranch',
    auth: true,
    key: ['services.branches.financial'],

  },
  {
    element: lazyLoadRoutes('TransferCredit/TransferToImprest'), // انتقال وجه تنخواه گردان
    path: '/TransferToImprest',
    auth: true,
    key: ['services.imprest.financial'],
  },

  {
    element: lazyLoadRoutes('TransferCredit/WithdrawToParent'), // دشارژ در عملیات تنخواه گردان
    path: '/WithdrawToParent/:id',
    auth: true,
    key: ['services.imprest.financial'],
  },



  {
    element: lazyLoadRoutes('TransferCredit/TransferToCustomer'), // انتقال وجه مشتریان
    path: '/TransferToCustomer',
    auth: true,
    key: ['financial.followers.list.customer-invoices.transfer.button']
  },
  {
    element: lazyLoadRoutes('Delegation/DelegationToUser'), // تفیض وجه شعب ، تنخواه گردان ، زیر مجموعه
    path: '/DelegationToUser',
    auth: true,
    key: ['services.branches.financial', 'services.imprest.financial', 'services.subbusiness.delegation'],

  },


  //==================== SEPARATE BREADCUMBS =================================================
  {
    element: lazyLoadRoutes('IssueCards'),
    path: '/IssueCards',
    auth: true,
    // key: ["org.imprest.cards"],
  },
  {
    element: lazyLoadRoutes('Cards'),
    path: '/Imprest/Cards',
    auth: true,
    key: ["org.imprest.cards"],
  },

  {
    element: lazyLoadRoutes('DigitalAccount/MyDigitalAccount'),
    path: 'Imprest/Accounts',
    auth: true,
    key: ['org.imprest.accounts.list'],
  },

  {
    element: lazyLoadRoutes('TransferCredit/TransferCreditByMenu'),
    path: 'Imprest/TransferCredit',
    auth: true,
    key: ['org.imprest.accounts.transfer'],
  },

  {
    element: lazyLoadRoutes('SettlementList/settlementListWalletReport'), // درخواست تسویه دیجیتال
    path: 'Imprest/SettlementWallet',
    auth: true,
    key: ['org.imprest.accounts.settlement-list-wallet'],
  },

  {
    element: lazyLoadRoutes('Transactions/TransactionsWalletReport'),
    path: 'Imprest/TransactionsWallet',
    auth: true,
    key: ['org.imprest.accounts.digital.report'],
  },

  //============================================================================================

  {
    element: lazyLoadRoutes('BillPayment/createBillPayment'),
    path: 'BillsPayment',
    auth: true,
    key: ['utility.bill.inquiry'],
  },

  {
    element: lazyLoadRoutes('BillPayment/BillsPaymentList'),
    path: 'BillsPaymentList',
    auth: true,
    key: ['utility.bill.report'],
  },
    {
    element: lazyLoadRoutes('Dashboard/Sayah'),
    path: 'SayahInquiry',
    auth: true,
  },
  {
    element: lazyLoadRoutes('SignIn'),
    path: '/sign-in',
    auth: false,
  },
];

export default paths;